<div class="couleur-page">
  <div class="couleur-page__header">
    <h2>Thème de couleurs</h2>

    <div class="header-actions">
      <app-ui-button
        type="button"
        variant="outline"
        size="sm"
        label="Restaurer le défaut"
        iconLeft="restart_alt"
        [disabled]="!hasDefault || restoring"
        (clicked)="onRestoreDefault()"
      ></app-ui-button>

      <app-ui-button
        type="button"
        variant="secondary"
        size="sm"
        [label]="savingDefault ? 'Enregistrement…' : 'Définir comme défaut'"
        iconLeft="bookmark"
        [loading]="savingDefault"
        [disabled]="savingDefault"
        (clicked)="onSetAsDefault()"
      ></app-ui-button>
    </div>
  </div>

  @if (loading) {
    <p>Chargement…</p>
  } @else {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="color-grid">
        @for (field of fields; track field.key) {
          <div class="color-field">
            <label [for]="field.key">{{ field.label }}</label>
            <input
              type="color"
              [id]="field.key"
              [formControlName]="field.key"
              (input)="onColorInput(field.key, $event)"
            />
            <span class="color-field__hint">{{ field.hint }}</span>
          </div>
        }
      </div>

      <div class="footer-actions">
        <app-ui-button
          type="button"
          variant="danger-hover"
          label="Annuler"
          [disabled]="saving"
          (clicked)="onCancel()"
        ></app-ui-button>

        <app-ui-button
          type="submit"
          variant="primary"
          [label]="saving ? 'Enregistrement…' : 'Enregistrer'"
          [loading]="saving"
          [disabled]="saving"
        ></app-ui-button>
      </div>
    </form>
  }
</div>